import { IStateProvider } from 'angular-ui-router';

import { SdcStateBuilder } from './sdc-state-builder.service';

MarkingPeriodRouteConfig.$inject = ['$stateProvider'];

const SDC_KEY = 'marking-period';

export function MarkingPeriodRouteConfig($stateProvider: IStateProvider) {
  const mpGridState = SdcStateBuilder.buildGridState(SDC_KEY);
  const mpProfileState = SdcStateBuilder.buildProfileState(SDC_KEY);

  $stateProvider

    .state(`main.school.new-sdc.${SDC_KEY}`, {
      abstract: true,
      url: `/${SDC_KEY}`,
      template: `
      <sdc-root
      current-user="$resolve.currentUser"
      current-state="$resolve.currentState">
      </sdc-root>
      `,
    })

    .state(`main.school.new-sdc.${SDC_KEY}.grid`, mpGridState)
    .state(`main.school.new-sdc.${SDC_KEY}.profile`, mpProfileState);
}
